export const transferSearchToData = ({ query }) => {
    return query || {}
}
